import { isMobileView } from "@sis/react-library";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { scheduleState } from "../../../redux/schedule/scheduleSlice";
import { LoadingBackground } from "../../shared/LoadingBackground";
import { ScheduleEvents } from "./scheduleEvents/ScheduleEvents";
import { ScheduleMeetings } from "./scheduleMeetings/ScheduleMeetings";
import { getSearchCategory, getSearchDate, getMeetingsToDisplay } from "../schedulePage/schedulePageHelper";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { rdsState } from "../../../redux/rds/rdsSlice";
import { loadScheduleEvents, removeScheduleEventsLoaded } from "../../../redux/schedule/scheduleActions";
import { loadRdsEventStatusesFromMeeting } from "../../../redux/rds/rdsActionsEventStatus";

export const ScheduleMainPage = () => {

  const [selectedMeetings, setSelectedMeetings] = useState<number[]>([])
  const [meetingsSectionOpen, setMeetingsSectionOpen] = useState(true)

  const rds = useAppSelector(rdsState);
  const schedule = useAppSelector(scheduleState);
  const dispatch = useAppDispatch();
  const isMobile = isMobileView();

  const [searchParams] = useSearchParams();

  const searchDate = getSearchDate(searchParams);
  const searchCategory = getSearchCategory(searchParams);

  const meetingsToDisplay = getMeetingsToDisplay(rds, searchParams);

  useEffect(() => {
    // The rdsEvents are loaded gradually, reset the array that keeps track of what is loaded
    // The scheduleEventsLoaded keeps track
    dispatch(removeScheduleEventsLoaded());
    // we only want the conditions below
    // eslint-disable-next-line
  }, [searchParams])

  useEffect(() => {
    meetingsToDisplay.forEach((m) => {
      dispatch(loadScheduleEvents(m.id))
    })
    // we only want the conditions below
    // eslint-disable-next-line
  }, [rds.rdsEvents])

  const handleMeetingSelected = (meetingId: number) => {
    const hasSelectedMeeting = selectedMeetings.find((sm) => sm === meetingId);
    if (hasSelectedMeeting) {
      setSelectedMeetings(selectedMeetings.filter((sm) => sm !== meetingId));
    } else {
      setSelectedMeetings([...selectedMeetings, ...meetingsToDisplay.filter((m) => m.id === meetingId).map((m) => m.id)]);
      dispatch(loadRdsEventStatusesFromMeeting(meetingId));
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {(schedule.loadingSideMenu || schedule.loading) &&
        <LoadingBackground top={100} left={`calc(50vw - ${isMobile ? 40 : 200}px)`} />
      }
      {searchDate && searchCategory &&
        <>
          <ScheduleMeetings
            meetings={meetingsToDisplay}
            searchDate={searchDate}
            selectedMeetings={selectedMeetings}
            onSelected={handleMeetingSelected}
            onCollapsed={(open) => { setMeetingsSectionOpen(open) }}
          />
          <ScheduleEvents
            meetings={meetingsToDisplay}
            selectedMeetings={selectedMeetings}
            meetingSectionOpen={meetingsSectionOpen}
          />
        </>
      }
    </Box>
  )
}